module.exports = __webpack_public_path__ + "resources/img/img_ai_easymaker.c20b0432b245d60f5826399e58be1b59.png";